import { AudioManager } from "../AudioManager";
import { GameVars } from "../GameVars";

export class Button extends Phaser.GameObjects.Image {

    private defaultScale: { x: number, y: number };
    private frameOn: string;
    private frameOff: string;

    constructor(scene: Phaser.Scene, x: number, y: number, textureAtlas: string, frameNameOff: string, frameNameOn: string = frameNameOff, pixelPerfect?: boolean) {

        super(scene, x, y, textureAtlas, frameNameOff);

        if (pixelPerfect) {
            this.setInteractive({pixelPerfect: true, useHandCursor: true});
        } else {
            this.setInteractive({useHandCursor: true});
        }

        this.frameOn = frameNameOn;
        this.frameOff = frameNameOff;

        if (frameNameOff !== frameNameOn) {
            this.on("pointerover", () => {
                this.setFrame(frameNameOn);
            }, this);

            this.on("pointerout", () => {
                this.setFrame(frameNameOff);
            }, this);

            this.on("pointerdown", () => {
                this.setFrame(frameNameOn);
                AudioManager.playSound("btn_press");
            }, this);

            this.on("pointerup", () => {
                this.setFrame(frameNameOff);
            }, this);
        }
    }

    public disable(): void {

        this.disableInteractive();
        this.alpha = .5;
        this.setFrame(this.frameOff);
    }

    public enable(): void {
            
        this.setInteractive({useHandCursor: true});
        this.alpha = 1;
    }

    public setFrames(frameNameOff: string, frameNameOn: string = frameNameOff): void {

        this.on("pointerover", () => {
            this.setFrame(frameNameOn);
        }, this);

        this.on("pointerout", () => {
            this.setFrame(frameNameOff);
        }, this);

        this.on("pointerdown", () => {
            this.setFrame(frameNameOn);
        }, this);

        this.on("pointerup", () => {
            this.setFrame(frameNameOff);
        }, this);
    }

    public setInflationTween(ratio: number, defaultScaleX: number = this.scaleX, defaultScaleY: number = this.scaleY, tween?: boolean, tweenData?: { ease: any, duration: number }): void {

        this.setScale(defaultScaleX, defaultScaleY);
        this.defaultScale = { x: defaultScaleX, y: defaultScaleY };

        if (tween) {
            if (!tweenData) {
                tweenData = { ease: Phaser.Math.Easing.Cubic.Out, duration: 200 };
            }
        }

        this.on("pointerover", () => {
            if (tween) {
                this.scene.tweens.add({
                    targets: [this],
                    scaleX: this.defaultScale.x * ratio,
                    scaleY: this.defaultScale.y * ratio,
                    ease: tweenData.ease,
                    duration: tweenData.duration,

                });
            } else {
                this.setScale(this.defaultScale.x * ratio, this.defaultScale.y * ratio);
            }
        }, this);

        this.on("pointerout", () => {
            if (tween) {
                this.scene.tweens.add({
                    targets: [this],
                    scaleX: this.defaultScale.x,
                    scaleY: this.defaultScale.y,
                    ease: tweenData.ease,
                    duration: tweenData.duration,

                });
            } else {
                this.setScale(this.defaultScale.x, this.defaultScale.y);
            }
        }, this);

        this.on("pointerdown", () => {
            if (!GameVars.isMobile) {
                this.setScale(this.defaultScale.x, this.defaultScale.y);
            } else {
                this.setScale(this.defaultScale.x * ratio, this.defaultScale.y * ratio);
            }
        }, this);

        this.on("pointerup", () => {
            if (!GameVars.isMobile) {
                this.setScale(this.defaultScale.x * ratio, this.defaultScale.y * ratio);
            } else {
                this.setScale(this.defaultScale.x, this.defaultScale.y);
            }
        }, this);
    }

    public onUp(f: Function, context: any): void {
        this.on("pointerup", f, context);
    }

    public onDown(f: Function, context: any): void {
        this.on("pointerdown", f, context);
    }

    public onOver(f: Function, context: any): void {
        this.on("pointerover", f, context);
    }

    public onOut(f: Function, context: any): void {
        this.on("pointerout", f, context);
    }
}

